import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';

@CaslSubject(AppSubjectEnum.VEHICLE_GPS_TRACKING)
export class VehicleGpsTrackingRecordDto extends BaseDto {
  vehicleId!: number;
  vehicleVin!: string;
  vehicleLicensePlate!: string;
  coordinates!: [number, number];
}
